
// export default App;


// import Login from './pages/login/Login';
// import Home from './pages/home/Home';
// import Quiz from './pages/quiz/Quiz';
// import Result from './pages/result/Result';

// import {
//   createBrowserRouter,
//   RouterProvider,
//   Navigate,
// } from "react-router-dom";

// import { useContext } from "react";
// import { AuthContext } from './context/authContext';
// import Scorce from './pages/scores/Scorce';
// import LifeIndk from './pages/home/LifeIndk';

// function App() {
//   const { currentUser } = useContext(AuthContext);

//   // ProtectedRoute component to protect routes if the user is not logged in
//   const ProtectedRoute = ({ children }) => {
//     if (!currentUser) {
//       return <Navigate to="/login" replace />; // Redirect to login if not authenticated
//     }
//     return children;
//   };

//   // PublicRoute component to handle login access after authentication
//   const PublicRoute = ({ children }) => {
//     if (currentUser) {
//       return <Navigate to="/" replace />; // Redirect to home if already logged in
//     }
//     return children;
//   };

//   // Router setup
//   const router = createBrowserRouter([
//     {
//       path: "/",
//       element: (
//         <ProtectedRoute>
//           <Home />
//         </ProtectedRoute>
//       ),
//     },
//     {
//       path: "/quiz",
//       element: (
//         <ProtectedRoute>
//           <Quiz />
//         </ProtectedRoute>
//       ),
//     },
//         {
//       path: "/lndkingdom",
//       element: (
//         <ProtectedRoute>
//           <LifeIndk />
//         </ProtectedRoute>
//       ),
//     },
//     {
//       path: "/result",
//       element: (
//         <ProtectedRoute>
//           <Result />
//         </ProtectedRoute>
//       ),
//     },
//     {
//       path: "/score",
//       element: (
//         <ProtectedRoute>
//           <Scorce />
//         </ProtectedRoute>
//       ),
//     },
//     {
//       path: "/login",
//       element: (
//         <PublicRoute>
//           <Login />
//         </PublicRoute>
//       ),
//     },
//     {
//       path: "*",
//       element: <Navigate to="/" replace />, // Redirect any unknown routes to home
//     },
//   ]);

//   return <RouterProvider router={router} />;
// }

// export default App;

import Login from './pages/login/Login';
import Home from './pages/home/Home';
import Quiz from './pages/quiz/Quiz';
import Result from './pages/result/Result';
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from './context/authContext';
import Scorce from './pages/scores/Scorce';
import LifeIndk from './pages/home/LifeIndk';

function App() {
  const { currentUser } = useContext(AuthContext);

  // Check if user is authenticated (either from context or localStorage)
  const isAuthenticated = () => {
    return currentUser || localStorage.getItem("ocos") !== null;
  };

  const ProtectedRoute = ({ children }) => {
    if (!isAuthenticated()) {
      return <Navigate to="/login" replace />;
    }
    return children;
  };

  const PublicRoute = ({ children }) => {
    if (isAuthenticated()) {
      return <Navigate to="/" replace />;
    }
    return children;
  };

  const router = createBrowserRouter([
    {
      path: "/",
      element: (
        <ProtectedRoute>
          <Home />
        </ProtectedRoute>
      ),
    },
    {
      path: "/quiz",
      element: (
        <ProtectedRoute>
          <Quiz />
        </ProtectedRoute>
      ),
    },
    {
      path: "/lndkingdom",
      element: (
        <ProtectedRoute>
          <LifeIndk />
        </ProtectedRoute>
      ),
    },
    {
      path: "/result",
      element: (
        <ProtectedRoute>
          <Result />
        </ProtectedRoute>
      ),
    },
    {
      path: "/score",
      element: (
        <ProtectedRoute>
          <Scorce />
        </ProtectedRoute>
      ),
    },
    {
      path: "/login",
      element: (
        <PublicRoute>
          <Login />
        </PublicRoute>
      ),
    },
    {
      path: "*",
      element: <Navigate to="/" replace />,
    },
  ]);

  return <RouterProvider router={router} />;
}

export default App;